// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"dataProductModal_modalBody__ci5Qw","loadingIndicator":"dataProductModal_loadingIndicator__1ba2r","saveBtn":"dataProductModal_saveBtn__1D-a7"};